// extracted by mini-css-extract-plugin
export default {"scrolloverflowtext":"TextOverflow_scrolloverflowtext__gH0nY","floatText":"TextOverflow_floatText__dQs3Q","breaklineoverflowtext":"TextOverflow_breaklineoverflowtext__jWyNU"};